import { InjectionToken } from '@angular/core';
import { AuthConfig } from './auth.interface';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AuthConfig');



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/auth/auth.config.ts